var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.visibility)?_c('div',{staticClass:"animated fadeIn"},[_c('b-row',{staticClass:"loader",attrs:{"align-v":"center"}},[_c('b-col',[_c('b-spinner'),_c('br'),_c('br'),_c('strong',[_vm._v(_vm._s(_vm.label))])],1)],1)],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }